import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./~/rmc-notification/es/index.js
// module id = 790
// module chunks = 106